'use client'

import { LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { logoutAction } from '@/app/actions/auth'

export default function Header() {
  return (
    <header className="sticky top-0 z-10 flex h-14 sm:h-16 shrink-0 items-center justify-between gap-x-3 border-b border-slate-200/60 bg-white/80 backdrop-blur-md px-3 sm:px-6 lg:px-8">
      {/* Desktop title */}
      <h2 className="hidden md:block text-xl font-semibold text-slate-800 truncate tracking-tight">
        Quản lý Kho
      </h2>
      {/* Mobile logo - compact */}
      <h2 className="md:hidden text-xl font-black tracking-tight uppercase flex items-center leading-tight">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-800 to-teal-500">LÊ HẢI</span>
      </h2>
      <div className="flex items-center gap-2">
        {/* Logout */}
        <form action={logoutAction} suppressHydrationWarning>
          {/* Desktop: full button */}
          <Button type="submit" variant="ghost" className="hidden sm:flex gap-2 rounded-full border border-gray-100 hover:bg-red-50 hover:text-red-700 hover:border-red-100 text-gray-600 transition-all px-4 shadow-sm h-10 font-bold group">
            <LogOut className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" />
            <span>Đăng xuất</span>
          </Button>
          {/* Mobile: icon-only compact button */}
          <Button type="submit" variant="ghost" size="icon" className="sm:hidden rounded-full border border-gray-100 hover:bg-red-50 hover:text-red-700 hover:border-red-100 text-gray-500 h-9 w-9 shadow-sm">
            <LogOut className="h-4 w-4" />
          </Button>
        </form>
      </div>
    </header>
  )
}
